<template>
  <transition-group
    name="staggered-fade"
    :css="false"
    appear
    v-bind="$attrs"
    @before-enter="beforeEnter"
    @enter="enter"
    @leave="leave"
  >
    <!-- Each element requires a data-index attribute in order for the transition to work properly -->
    <slot />
  </transition-group>
</template>
<script>
import Velocity from 'velocity-animate';
export default {
  name: 'TrimTransition',
  inheritAttrs: false,
  props: {
    duration: {
      type: Number,
      default: 200, // duration of each element transition
    },
    top: {
      type: Number,
      default: 0,
    },
    left: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 0,
    },
    tx: {
      type: Number,
      default: 0,
    },
    ty: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    beforeEnter(el) {
      el.style.opacity = 0;
      el.style.transformOrigin = 'left';
      el.style['max-width'] = this.width + 'px';
    },
    enter(el, done) {
      // Each element requires a data-index attribute in order for the transition to work properly
      el.parentElement.style.left = this.left + 'px';
      el.parentElement.style.top = this.top + 'px';
      const index = el.dataset.index || 1;
      var delay = index * this.duration;
      setTimeout(() => {
        Velocity(el, { opacity: 1 }, { complete: done });
      }, delay);
    },
    leave(el, done) {
      // Each element requires a data-index attribute in order for the transition to work properly
      var delay = 1;
      setTimeout(() => {
        const trans = {
          translateY: this.ty + 'px',
          translateX: this.tx + 'px',
          opacity: 0,
          width: 0,
        };
        Velocity(el, trans, { duration: 2000, complete: done });
      }, delay);
    },
  },
};
</script>
